import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class PochtaTariffDeliveryTimeDto
*  
*/
export class PochtaTariffDeliveryTimeDto extends ActiveModel {

  /**
  * ['min-days']
  *   */
  @ActiveField()
  ['min-days']?: null | number


  /**
  * ['max-days']
  *   */
  @ActiveField()
  ['max-days']?: null | number
}
